<template>
  <div id="chatbot-footer">
    <chatbotConnectSearch
      v-if="ifQuestionList"
      v-show="showQuestionList"
      @clearInput="emptyInput"
      @showDialog="handleDialogVisibility"
    />
    <div class="chatbot-footer-input">
      <el-input
        id="chatbot-footer-input"
        v-model="inputValue"
        class="chatbot-footer-input"
        placeholder="请输入关键字，搜索您要的问题。"
        @blur="hanldeInputBlur"
        @focus="handleInputFocus"
      >
      </el-input>
      <!-- <label for="chatbot-footer-input" style="position: relative; top: -70px;">12341234</label> -->
    </div>
    <ChatbotDialog
      :initial-dialog-visible="contactDialogVisible"
      @sendDialogActionValue="getDialogActionValue"
    />
  </div>
</template>

<script>
import chatbotConnectSearch from "@/components/connectSearch";
import ChatbotDialog from "@/components/Dialog";
import { getAssociateSearchList } from "@/api/chatbot";
import { IndexPageModule } from "@/settings";

export default {
  name: "ChatbotFooter",
  components: {
    chatbotConnectSearch,
    ChatbotDialog,
  },
  data() {
    return {
      inputValue: "", //初始化值
      showQuestionList: false,
      ifQuestionList: false,
      questionList: [],
      contactDialogVisible: false,
    };
  },
  watch: {
    inputValue(val, oldVal) {
      if (val !== "" && val !== oldVal && val.length >= 2) {
        this.showQuestionList = false;
        this.ifQuestionList = true;
        this.getAutoComplete(val);
      } else {
        this.ifQuestionList = false;
      }
    },
  },
  methods: {
    async getAutoComplete(input) {
      try {
        const data = await getAssociateSearchList({
          //获取api数据
          userInput: input, //用户输入的关键字
        });
        if (data.code !== 200) {
          this.questionList = []
        } else {
          let resultList = data.data; //获取data对象的data数组
          // console.log("api返回结果", resultList);
          for (let i = 0; i < IndexPageModule.length; i++) {
            const { value } = IndexPageModule[i];
            const index = resultList.indexOf(value);
            if (index !== -1) {
              delete resultList[index];
            }
            resultList = resultList.filter((item) => item);
          }
          // console.log("删除指定字符结果", resultList);
          //联想请求结果
          if (resultList !== null && resultList.length > 0) {
            this.questionList = resultList.map((item) => {
              let obj = {
                text: item,
                html: "",
              };
              const strList = Array.from(new Set(input.split(""))); //遍历成正真的数组形式并存入  this.lastInput=input，输入的值；  Array.from(new Set)去重
              for (const str of item) {
                strList.includes(str)
                  ? (obj.html += `<span style="color: #D93225">${str}</span>`)
                  : (obj.html += str); //${}ES6语法类似插值
              }
              // console.log("obj", obj);
              return obj;
            });
          }
        }
        this.$store.commit("set_questionList", this.questionList);
        this.showQuestionList = true;
      } catch ({ message }) {
        console.log("异常", message);
      }
    },
    handleInputFocus:function(){
      setInterval(function(){
        document.querySelector('#chatbot-footer-input').scrollIntoView(true)
      }, 400)
    },
    hanldeInputBlur: function () {
      //在Input控件失去焦点触发
      setTimeout(() => {
        this.inputValue = "";
      }, 0);
    },
    emptyInput: function () {
      this.inputValue = "";
      this.showQuestionList = false;
      this.$store.commit("set_questionList", []);
    },
    showContactDialog() {
      this.contactDialogVisible = true;
    },
    getDialogActionValue(value) {
      this.contactDialogVisible = value;
    },
    handleDialogVisibility() {
      this.contactDialogVisible = true;
      this.emptyInput();
    },
  },
};
</script>

<style lang="scss">
.el-footer{
  padding: 0px 10px;
  height: 50px !important;
}
#chatbot-footer {
  width: 100%;
  height:50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  background-color: #fff;
}

.chatbot-footer-input {
  line-height: 50px;
  width: calc(100vw - 20px);
}

.chatbot-footer-input {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    padding: 0 0 0 10px;
    background-color: rgba(239, 239, 239, 1);
    border-radius: 15px;
  }
  //去掉input的border高亮显示
  .el-input__inner:focus {
    border-color: #dcdfe6 !important;
  }

  //边框本身的颜色
  .el-input__inner {
    border: 1px solid #dcdfe6;
  }

  .el-input__inner:hover {
    border-color: #dcdfe6;
  }
}
</style>
